export enum EMiscActions {
  INIT_THEME = 'misc/INIT_THEME',
  SET_THEME = 'misc/SET_THEME',
  SAVE_PREV_LOCATION = 'misc/SAVE_PREV_LOCATION'
}
